import * as documentNatureConstants from "./documentNatureConstants";
import {CODE_PERSONA_NATURAL_061} from "./parametersConstants";
export function validationCalculateTaxes (document, contact = null) {
    contact = contact || document.contact;

    const contact_customer = contact.customer;
    const contact_provider = contact.provider;
    const document_nature = document.vouchertype.document_nature;
    const is_customer = contact.is_customer;
    const is_provider = contact.is_provider;
    const fiscal_responsibility = contact.fiscal_responsibility;

    if (is_customer && document_nature && document_nature.code_parameter
        && [documentNatureConstants.CODE_NATURALEZA_ORDEN_SERVICIO, documentNatureConstants.CODE_NATURALEZA_VENTAS,documentNatureConstants.CODE_NATURALEZA_REMISION_VENTAS_FACT,
            documentNatureConstants.CODE_NATURALEZA_DEVOL_VENTAS, documentNatureConstants.CODE_NATURALEZA_REMISION_VENTAS_FACTURADAS_WMS,
            documentNatureConstants.CODE_NATURALEZA_DEVOL_REMIS_VENTA, documentNatureConstants.CODE_NATURALEZA_ANULACION_REMIS_VENTA].includes(document_nature.code_parameter)
        && contact_customer && contact_customer.not_vat_charged) {
        return false;
    }

    if (is_provider && document_nature && document_nature.code_parameter
        && [documentNatureConstants.CODE_NATURALEZA_COMPRAS, documentNatureConstants.CODE_NATURALEZA_REMISION_COMPRAS, documentNatureConstants.CODE_NATURALEZA_DEVOL_COMPRAS,
            documentNatureConstants.CODE_NATURALEZA_GASTOS].includes(document_nature.code_parameter)
        && contact_provider && (contact_provider.not_vat_charged || (fiscal_responsibility && [CODE_PERSONA_NATURAL_061].includes(fiscal_responsibility.code_parameter)))) {
        return false;
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/util/taxes.js